import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Reward } from '@/models';
import { PurchasedReward } from '@/models/reward';
import { toTitleCase } from '@/helpers/formatting';
import { RewardsEvent } from '@/services/analytics/events/rewards-event';

@Component({
    name: 'CmgCyobRedemptionSuccessModal'
})

export default class CmgCyobRedemptionSuccessModal extends Vue {
    get purchasedReward(): PurchasedReward {
        return this.$appStore.state.ui.modals.cyobRedemptionSuccessModal.args!.purchasedReward;
    }

    get reward(): Reward {
        return this.$appStore.state.ui.modals.cyobRedemptionSuccessModal.args!.reward;
    }

    get rewardName(): string {
        return toTitleCase(this.reward.title);
    }

    get rewardImage(): string {
        return this.reward.mediaUri;
    }

    get modalTitle(): string {
        return `${this.rewardName} Redeemed`;
    }

    get modalCta(): string {
        return 'use reward';
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.cyobRedemptionSuccessModal.visible;
    }   

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get lottieBackgroundSparklesUrl(): string {
        return this.$appStore.state.cms.animations.bag.lottieBackgroundSparklesUrl;
    }

    formattedExpirationDate(): string {
        const expirationDate = this.purchasedReward.promotionExpirationDate;

        const date = new Date(expirationDate);

        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric'
        });
    }

    onClickTermsAndConditions(event: any) {
        const purchasedReward = this.purchasedReward;
        const reward = this.reward;
        const onBack = () => {
            this.$services.ui.setModalVisibility('cyobRedemptionSuccessModal', true, { purchasedReward, reward });
            this.$services.ui.setModalVisibility('rewardTermsAndConditions', false);
        };

        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('rewardTermsAndConditions', true, { termsAndConditions: purchasedReward.promotionTerms, onBack });
        this.$services.ui.firstFocus();
        this.$services.ui.setModalVisibility('cyobRedemptionSuccessModal', false);
    }

    setLoadingStatus(loading: boolean) {
        this.$services.ui.setAppBlur(loading);
        this.$services.ui.setAppPepperVisibility(loading);
    }

    sendRewardsAddedToBagAnalytics(rewardName: string, promotionCode: string, campaign: string, modalTitle: string, modalCta: string) {
        this.$services.analytics.send(
            new RewardsEvent({
                eventType: 'rewardsAddedToBag',
                rewardTitle: rewardName.toUpperCase(),
                rewardsPath: 'rewards-birthday',
                rewardsID: promotionCode,
                rewardsType: campaign,
                pageName: 'rewards:choose-birthday-reward',
                linkName: modalCta.toUpperCase(),
                linkTitle: modalTitle.toUpperCase()
            })
        );
    }

    async onClickUseReward() {
        const rewardName = this.rewardName;
        const promotionCode = this.purchasedReward.promotionCode;
        const purchasedReward = this.purchasedReward;
        const campaign = this.purchasedReward.promotionCampaign;
        const modalCta = this.modalCta;
        const modalTitle = this.modalTitle.toUpperCase();

        this.$services.reward.addPromotionToBag(
            undefined,
            purchasedReward,
            () => { this.onClose(); }, 
            (loading: boolean) => { this.setLoadingStatus(loading) },
            () => { this.sendRewardsAddedToBagAnalytics(rewardName, promotionCode, campaign, modalTitle, modalCta); }
        );
    }

    onClose() {
        this.$services.ui.setModalVisibility('cyobRedemptionSuccessModal', false);
    }
}